import { render, staticRenderFns } from "./DialogWeb.vue?vue&type=template&id=1db4d039"
import script from "./DialogWeb.vue?vue&type=script&lang=js"
export * from "./DialogWeb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports